export default __webpack_public_path__ + "static/media/button_upload_vi.20a88d3e.svg";